Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var require_updateOptions = require('./updateOptions.cjs');
var require_getUsedExports = require('./getUsedExports.cjs');
//#region src/installInitialConsumes.ts
function handleInitialConsumes(options) {
    var moduleId = options.moduleId, moduleToHandlerMapping = options.moduleToHandlerMapping, webpackRequire = options.webpackRequire, asyncLoad = options.asyncLoad;
    var federationInstance = webpackRequire.federation.instance;
    if (!federationInstance) throw new Error("Federation instance not found!");
    var _moduleToHandlerMapping_moduleId = moduleToHandlerMapping[moduleId], shareKey = _moduleToHandlerMapping_moduleId.shareKey, shareInfo = _moduleToHandlerMapping_moduleId.shareInfo;
    try {
        var usedExports = require_getUsedExports.getUsedExports(webpackRequire, shareKey);
        var customShareInfo = _object_spread._({}, shareInfo);
        if (usedExports) customShareInfo.treeShaking = {
            usedExports,
            useIn: [
                federationInstance.options.name
            ]
        };
        if (asyncLoad) return federationInstance.loadShare(shareKey, {
            customShareInfo
        });
        return federationInstance.loadShareSync(shareKey, {
            customShareInfo
        });
    } catch (err) {
        console.error("loadShareSync failed! The function should not be called unless you set \"eager:true\". If you do not set it, and encounter this issue, you can check whether an async boundary is implemented.");
        console.error("The original error message is as follows: ");
        throw err;
    }
}
function installInitialConsumes(options) {
    require_updateOptions.updateConsumeOptions(options);
    var moduleToHandlerMapping = options.moduleToHandlerMapping, webpackRequire = options.webpackRequire, installedModules = options.installedModules, initialConsumes = options.initialConsumes, asyncLoad = options.asyncLoad;
    var factoryIdSets = [];
    initialConsumes.forEach((id)=>{
        var factoryGetter = ()=>handleInitialConsumes({
                moduleId: id,
                moduleToHandlerMapping,
                webpackRequire,
                asyncLoad
            });
        factoryIdSets.push([
            id,
            factoryGetter
        ]);
    });
    var setModule = (id, factoryGetter)=>{
        webpackRequire.m[id] = (module)=>{
            var _shareInfo_shareConfig;
            installedModules[id] = 0;
            delete webpackRequire.c[id];
            var factory = factoryGetter();
            if (typeof factory !== "function") throw new Error(`Shared module is not available for eager consumption: ${id}`);
            var result = factory();
            var shareInfo = moduleToHandlerMapping[id].shareInfo;
            if ((shareInfo === null || shareInfo === void 0 ? void 0 : (_shareInfo_shareConfig = shareInfo.shareConfig) === null || _shareInfo_shareConfig === void 0 ? void 0 : _shareInfo_shareConfig.layer) && result && typeof result === "object") try {
                if (!result.hasOwnProperty("layer") || result.layer === void 0) result.layer = shareInfo.shareConfig.layer;
            } catch (e) {}
            module.exports = result;
        };
    };
    if (asyncLoad) return Promise.all(factoryIdSets.map((param)=>{
        var _param = _sliced_to_array._(param, 2), id = _param[0], factoryGetter = _param[1];
        return _async_to_generator._(function*() {
            var result = yield factoryGetter();
            setModule(id, ()=>result);
        })();
    }));
    factoryIdSets.forEach((param)=>{
        var _param = _sliced_to_array._(param, 2), id = _param[0], factoryGetter = _param[1];
        setModule(id, factoryGetter);
    });
}
//#endregion
exports.installInitialConsumes = installInitialConsumes; //# sourceMappingURL=installInitialConsumes.cjs.map
